import { useQuery } from "@tanstack/react-query";
import api from "../../services/api";
import { parsePaginatedResponse } from "../../utils/parsePaginatedResponse";

const INDUSTRY_KEYS = ["industry", "industries"];

export const useViewIndustryQuery = ({ page, limit, q } = {}) => {
  const isPaginated = page !== undefined && limit !== undefined;
  const trimmedQ = q?.trim?.() ?? "";

  return useQuery({
    queryKey: isPaginated
      ? ["viewIndustry", page, limit, trimmedQ]
      : ["viewIndustry"],
    queryFn: async () => {
      const params = {};
      if (isPaginated) {
        params.page = page;
        params.limit = limit;
        if (trimmedQ) params.q = trimmedQ;
      }

      const res = await api.get("/industry/all", { params });

      if (isPaginated) {
        const parsed = parsePaginatedResponse(res.data, INDUSTRY_KEYS, limit);
        return {
          industries: parsed.items,
          pagination: parsed.pagination,
        };
      }

      return res.data;
    },
    placeholderData: isPaginated
      ? (previousData) => previousData
      : undefined,
    staleTime: isPaginated ? 60_000 : undefined,
  });
};
